<template>
  <div>
    <router-link to="/">Home</router-link> |
    <router-link to="/analysis">Analysis</router-link> |
    <router-link to="/faqs">FAQs</router-link> |
    <router-link to="/meetings">Meetings</router-link> |
    <router-link to="/search">Search</router-link> |
    <router-link to="/sandbox">Sandbox</router-link>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
